<template>
    <div class="BottomCharts">
        <PublicEcharts id="BottomCharts" :chartsData="orderData" :type="'ringChart'" :options="dealOption()"
            usePropsOptions />
    </div>
</template>

<script>
import PublicEcharts from "@/components/PublicEcharts";
import { dealBigNum, amountFun } from "@/assets/js/utils";
export default {
    name: "BottomCharts",
    props: {},
    components: { PublicEcharts },
    data() {
        return {
            orderData: {
                "dataArr": [
                    { "name": "学校", "value": 2 },
                    { "name": "医院", "value": 3 },
                    { "name": "工业企业", "value": 5 },                  
                    { "name": "行政事业", "value": 3 },  
                    { "name": "办公", "value": 2 },
                    { "name": "综合商业", "value": 2 },                                    
                    { "name": "综合集团", "value": 1 },
                    { "name": "酒店", "value": 3 },
                ]
            }
        }
    },
    computed: {},
    methods: {
        dealBigNum,
        amountFun,
        dealOption() {
            const paramObj = this.orderData
            let tol = 0;
            tol = amountFun(paramObj.dataArr)
            const option = {
                title: {
                    text: tol == 0 ? "0" : tol,
                    x: "27%",
                    y: "40%",
                    textAlign: 'center',
                    // textVerticalAlign:'middle',
                    textStyle: {
                        color: "#fff",
                        fontSize: 20,
                        align: "center",
                    },
                    subtext: "项目总数",
                    subtextStyle: {
                        fontSize: 12,
                        color: "#16E9F4",
                    },
                },
                tooltip: {
                    trigger: "item",
                    formatter: function (param) {
                        return `${param.name}:${dealBigNum(param.value)} ${param.percent == undefined ? 0 : param.percent}%`
                    },
                },
                legend: {
                    // type: 'scroll',
                    orient: 'vertical',
                    right: 0,
                    top: 'middle',
                    // bottom: 40,
                    textStyle: {
                        color: '#A1A7B8',
                        fontSize: 14,
                    },
                    height:100,
                },
                color: [
                    "#26D9D4",
                    "#F2D397",
                    "#4398EB",                 
                    "#74AE8B",
                    "#636CCA",
                    "#E48784",                   
                    "#ACCBE1",
                    "#D2E5D2",
                    "#A68CD7",
                    "#B49590",
                ],
                series: [
                    {
                        type: "pie",
                        radius: ["45%", "60%"],
                        center: ['28%', '50%'],
                        data: paramObj.dataArr,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                        label: {
                            bleedMargin:0,
                            // alignTo: "edge", // label两端对称布局
                            // edgeDistance: 10, // 布局为两端对称时候需要外边距防止图表变形 数值随意不要太大
                            distanceToLabelLine: -2, // label距离引导线距离
                            formatter: function (param) {
                                return (
                                    "{a|" +
                                    (param.percent == undefined ? 0 : param.percent) +
                                    "%" +
                                    // "}\n{hr|}\n" +
                                    // "{d|" +
                                    // param.name +
                                    "}"
                                );
                            },
                            rich: {
                                a: {
                                    color: "#fff",
                                    fontSize: 12,
                                },
                                // d: {
                                //     padding: [0, 10, 4, 10],
                                //     color: "#A1A7B8",
                                // },
                                // hr: {
                                //   borderWidth: 1,
                                //   width: "100%",
                                //   height: 0,
                                //   borderColor: "#A1A7B8",
                                // },
                            },
                        },
                    }
                ],
            };
            return option
        }
    },
    created() {
    },
    mounted() {
    },
}
</script> 

<style lang="scss" scoped>
.BottomCharts {
    width: 100%;
    height: 100%;
}
</style>